import Layout from '@/layout/index.vue';

export default [
  {
    path: '/boardManage',
    redirect: '/boardManage/formal/dcopsOperation/serverMove',
  },
  {
    path: '/boardManage/formal',
    component: Layout,
    name: 'boardManage',
    meta: {
      title: '数据运营',
      icon: 'el-icon-s-finance',
      alwaysShow: true, // 即使只有一个子路由也显示父级菜单
    },
    children: [
      {
        path: 'dcopsOperation',
        name: 'dcopsOperation',
        component: () => import('@/views/appManage/layout.vue'),
        alwaysShow: true,
        meta: { title: 'Dcops工单运营', icon: 'el-icon-data-analysis' },
        children: [
          {
            path: 'serverMove',
            name: 'dcopsOperationServerMove',
            component: () => import('@/views/boardManage/dataOperation/dcops_move_board.vue'),
            meta: { title: '服务器搬迁', icon: 'el-icon-s-platform' },
          },
        ],
      },
    ],
  },
];
